/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  EnrichedSearchUserOrganisationRequest,
  EnrichedUserOrganisationPageResponse,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class UserOrganisationController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags user-organisation-controller
   * @name SearchUserOrganisation
   * @request POST:/api/v1/users/organisations/search
   */
  searchUserOrganisation = (
    data: EnrichedSearchUserOrganisationRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<EnrichedUserOrganisationPageResponse, any>({
      path: `/v1/users/organisations/search`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static searchUserOrganisationPath = '/v1/users/organisations/search'
  static searchUserOrganisationMethod = 'POST'
  /**
   * No description
   *
   * @tags user-organisation-controller
   * @name DownloadUserOrganisationLogoThumbnail
   * @request GET:/api/v1/users/organisations/{organisationId}/logos/{fileId}/thumbnail
   */
  downloadUserOrganisationLogoThumbnail = (
    organisationId: string,
    fileId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<File, any>({
      path: `/v1/users/organisations/${organisationId}/logos/${fileId}/thumbnail`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static downloadUserOrganisationLogoThumbnailPath =
    '/v1/users/organisations/${organisationId}/logos/${fileId}/thumbnail'
  static downloadUserOrganisationLogoThumbnailMethod = 'GET'
}
